module.exports = __webpack_public_path__ + "static/media/Group (5).0b018bb3.svg";